import Modal from 'react-modal';
const DefaultModal = (props) => {
    return (
        <Modal
            isOpen={props.modal}
            ariaHideApp={false}
            className="modal3"
            shouldCloseOnOverlayClick={true}
            onRequestClose={() => { props.setModal(false) }}
        >
            {props.element}
        </Modal>
    )
}
export default DefaultModal